<script setup lang="ts">
import {
  useBrowserStore,
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';
import { TabKey } from '@apps/main/new-desktop/core/stores/configurationPanel/configurationPanelStore.model';

import {
  useTripOverviewModalsStore,
  useTripOverviewPanelsStore,
} from '../../stores';

import TripOverviewHeaderDesktop from './TripOverviewHeaderDesktop.vue';
import TripOverviewNewHeaderDesktop from './TripOverviewNewHeaderDesktop.vue';
import TripOverviewHeaderMoblie from './TripOverviewHeaderMoblie.vue';

const tripOverviewModalsStore = useTripOverviewModalsStore();
const tripOverviewPanelsStore = useTripOverviewPanelsStore();
const browserStore = useBrowserStore();
const statsigEventsStore = useStatsigEventsStore();
const routerStore = useRouterStore();

function openPaxSelectorModal(): void {
  if (browserStore.isLargerThan899px) {
    tripOverviewModalsStore.openPaxSelectorModal();
  } else {
    tripOverviewPanelsStore.openConfigurationPanel(
      TabKey.Pax,
      'overview-header-actions'
    );
  }
}

function openEditTripModal(): void {
  if (browserStore.isLargerThan899px) {
    tripOverviewModalsStore.openEditTripModal();
  } else {
    tripOverviewPanelsStore.openConfigurationPanel(
      TabKey.Itinerary,
      'overview-header-actions'
    );
  }
}

function onHomeAirportClick(): void {
  tripOverviewModalsStore.openAddFlightsModal();
  statsigEventsStore.logTripOverviewFlyFromButtonClicked();
}

function openMonthsSelectorModal(): void {
  if (browserStore.isSmallerThan900px) {
    tripOverviewPanelsStore.openConfigurationPanel(
      TabKey.Calendar,
      'overview-header-actions'
    );
  } else {
    tripOverviewModalsStore.openTripCalendarModal();
  }
}

function openPremadeTripDetailsModal(): void {
  tripOverviewModalsStore.openPremadeTripDetailsModal();
}

function navigateToCarTrip(): void {
  routerStore.navigateToCarTrip();
}
</script>

<template>
  <TripOverviewHeaderMoblie
    v-if="browserStore.isSmallerThan900px"
    @open-premade-trip="openPremadeTripDetailsModal"
    @pax-click="openPaxSelectorModal"
    @home-airport-click="onHomeAirportClick"
    @edit-trip="openEditTripModal()"
    @months-selector-click="openMonthsSelectorModal()"
    @navigate-to-car-trip="navigateToCarTrip"
  />
  <TripOverviewHeaderDesktop
    v-else-if="browserStore.isSmallerThan1200px"
    :print-mode="false"
    @open-premade-trip="openPremadeTripDetailsModal"
    @pax-click="openPaxSelectorModal"
    @home-airport-click="onHomeAirportClick"
    @edit-trip="openEditTripModal()"
    @months-selector-click="openMonthsSelectorModal()"
    @navigate-to-car-trip="navigateToCarTrip"
  />
  <TripOverviewNewHeaderDesktop
    v-else
    @pax-click="openPaxSelectorModal"
    @home-airport-click="onHomeAirportClick"
    @edit-trip="openEditTripModal()"
    @months-selector-click="openMonthsSelectorModal()"
  />
</template>
